// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"662e0017","197":"e3eef73f","618":"b793927e","622":"dddae1d9","992":"29d91f0b"}[chunkId] + ".chunk.js";
};